module.exports = __webpack_public_path__ + "static/media/footer-bg.9e45fd16.svg";